import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppState } from '../../storage/app-state';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-loading-spinner',
  imports: [CommonModule, ProgressSpinnerModule],
  templateUrl: './loading-spinner.html',
  styleUrl: './loading-spinner.scss'
})
export class LoadingSpinner {
  protected appState = inject(AppState);
}
